import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/hand_peace.svg'


const _withScopeId = n => (_pushScopeId("data-v-63373ec6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modalContent" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))
const _hoisted_5 = { class: "w-100 mt-5 pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_localized_text, {
          type: "h1",
          localizedKey: "app_QR Code valido!",
          text: "QR Code valido!"
        }),
        _createVNode(_component_localized_text, {
          type: "h1",
          localizedKey: "app_15 punti per te",
          text: "15 punti per te"
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-primary w-100 mx-auto mb-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.callback('/profile')))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_Home",
              text: "Home"
            })
          ]),
          _createElementVNode("button", {
            class: "btn btn-secondary w-100 mx-auto",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.callback('/ranking')))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_Classifica",
              text: "Classifica"
            })
          ])
        ])
      ])
    ])
  ]))
}